$(function() {
    var potentiallyReaddedProducts = {};

    var checkedAllButtons = setInterval(function() {
        if ($('[data-swaction="addToWishlist"]:not([data-removed-default="yes"])').length === 0) {
            clearInterval(checkedAllButtons);
        } else {
            $('[data-swaction="addToWishlist"]:not([data-removed-default="yes"])').each(function () {
                if ($(this).data("removed-default") !== "yes") {
                    $(this).off('click');
                    $(this).data("removed-default", "yes");
                    $(this).click(function (e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        var $wishlistButton = $(this);
                        if ($wishlistButton.hasClass('swym-added') && !$wishlistButton.hasClass('swym-adding')) {
                            $wishlistButton.addClass('swym-adding');
                            var productId = $(this).data('product-id');
                            window._swat.fetch(function (r) {
                                for (var x = 0; x < r.length; x++) {
                                    if (r[x].empi === productId) {
                                        window._swat.removeFromWishList(
                                            r[x],
                                            function (r) {
                                                $wishlistButton.removeClass('swym-added');
                                                $wishlistButton.removeClass('swym-adding');
                                                $wishlistButton.removeClass('disabled');
                                            }
                                        );
                                    }
                                }
                            });
                        } else if (!$wishlistButton.hasClass('swym-adding')) {
                            $wishlistButton.addClass('swym-adding');
                            var productId = $(this).data('product-id');
                            window._swat.addToWishList(
                                {
                                    epi: window.SwymViewProducts[productId].epi,
                                    empi: window.SwymViewProducts[productId].empi
                                },
                                function (r) {
                                    if (!$wishlistButton.hasClass('swym-added')) {
                                        $wishlistButton.addClass('swym-added');
                                    }
                                    $wishlistButton.removeClass('swym-adding');
                                    $wishlistButton.removeClass('disabled');
                                    addWishlistNotificationText($wishlistButton);
                                }
                            );
                        }
                    });
                }
            });
        }
    }, 100);
});